export default __webpack_public_path__ + "static/transforming-travel-query-management-5348013eaa7556644a300855b24eceac.jpg";